module.exports = __webpack_public_path__ + "static/media/tbu_head_bg.ac5e9cd9.jpg";